import React from "react";
import "./Whats_Covered_In_Your_Trip.css";
import Common_Title from "../../../common_component/common_title/Common_Title";

function WhatsCoveredTrip({ data }) {
  return (
    <section className="trip_cover_section">
      <div className="container">
        <div className="head_title">
          <Common_Title title="Whats Covered In Your Trip" />
        </div>

        <div className="trip_card">
          <div className="row">
            {/* Inclusions */}

            <div className="col-lg-6 inclusion_col">
              <h4 className="cover_heading">Inclusions</h4>

              <ul className="cover_list inclusion_list">
                <li>
                  <i className="fa-solid fa-circle-check"></i>
                  <div
                    className="inclusions-list"
                    dangerouslySetInnerHTML={{ __html: data?.inclusions }}
                  />
                </li>
              </ul>
            </div>

            {/* Exclusions */}

            <div className="col-lg-6 exclusion_col">
              <h4 className="cover_heading">Exclusions</h4>

              <ul className="cover_list exclusion_list">
                <li>
                  <i className="fa-regular fa-circle-xmark"></i>
                  <div dangerouslySetInnerHTML={{ __html: data?.exclusions }} />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhatsCoveredTrip;
